import React, { useState, useRef, useEffect, memo } from "react";
import "./CustomMoneyGramModal.scss";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import CustomStepWizard from "../UI/CustomStepWizard/CustomStepWizard";
import {
  Box,
  Typography,
  TextField,
  CircularProgress,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import { getMoneyGramUsers } from "../../util/API/moneygram";
import {
  getCustomerTypes,
  getCustomerSubTypes,
  NewUser, 
  PictureNew
} from "../../util/API/customers";
import MoneyGramTableDynamic from "../MoneyGramTableDynamic/MoneyGramTableDynamic";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowBackIos } from "@mui/icons-material";
import CustomForm from "../UI/CustomForm/CustomForm";
import { CheckIfEmailExists } from "../../util/API/operator";
import { createExternalAccounts } from "../../util/API/externalaccounts";
import MapIcon from '@mui/icons-material/Map';

function CustomMoneyGramModal({
  open,
  handleClose,
  updateState,
  conditionalFields,
  onCreate,
}) {
  const [userBase64, setUserBase64] = useState("");
  const [error, setError] = useState("");
  const [newUser, setNewUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    userId: "",
  });
  const [formDataCollected, setFormDataCollected] = useState({ });
  const [currentStep, setCurrentStep] = useState(0);
  const [isMerchant, setIsMerchant] = useState(false); // State to track if merchant fields are shown
  const [searchText, setSearchText] = useState("");
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [securityPermissions, setSecurityPermissions] = useState([]);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [filterType, setFilterType] = useState(null);

  const [customerTypes, setCustomerTypes] = useState([]);
  const [customerSubTypes, setCustomerSubTypes] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState("1");
  const [addBussinessToggleBit, setAddBussinessToggleBit] = useState(false);

  const formRef = useRef(null);
  const containerRef = useRef(null);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
  const triggerFields = ["ismerchant"]; // Add other fields as needed
  const isOperator = sessionStorage.getItem("isOperator");
  const parentuserid = sessionStorage.getItem("parentuserid");

  const closeModal = () => {
    if (formRef.current) {
      formRef.current.resetForm();
    }
    setUserData([]);
    setSearchText("");
    handleClose();
  };

  const [steps, setSteps] = useState([
    { label: "SelectUser", index: 0 },
    { label: "Personal", index: 1 },
    { label: "Contact", index: 2 },
  ]);

  // const steps = [
  //   { label: "SelectUser", index: 0 },
  //   { label: "Personal", index: 1 },
  //   { label: "Contact", index: 2 },
  //   // { label: "Business", index: 3 },
  //   // { label: "Employment", index: 2 },
  //   // ...(isMerchant ? [{ label: "Business", index: 2 }] : []),
  // ];

  const conditionalGroups = {
    "Business Information": (watch) => watch("ismerchant") === true || watch("ismerchant") === "true", 
  }

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex);
    const panel = containerRef.current.children[stepIndex];
    if (panel) {
      panel.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handlePrevious = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  // useEffect(() => {
  //   setFormDataCollected({});
  // }, [open]);

  const handleMoneyGramSearch = (searchText) => {
    setSearchText(searchText);
  };

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setSearchText(inputText);
    handleMoneyGramSearch(inputText);
  };

  const fetchTable = async () => {
    try {
      let response = await fetch(`/tables/moneyGramTable.json`);
      const formResponseData = await response.json();
      const userDataResponse = await getMoneyGramUsers(searchText);
      setUserData(userDataResponse);
      // dispatch(getUserList({ users: userDataResponse }));
    } catch (error) {
      console.error("Failed to fetch form data:", error);
    }
  };

  useEffect(() => {
    setFormDataCollected({});
    if(open==true) {
      fetchTable();
      fetchCustomerType();
    }
    // fetchMoneyGramUsers();
  }, [open]);

  const fetchMoneyGramUsers = async () => {
    if (!searchText.trim()) return;

    setLoading(true);

    try {
      const response = await getMoneyGramUsers(searchText);
      console.log("API Response:", response);

      if (response?.callStatus === "0") {
        setUserData([]);
        return;
      }

      let fetchedData = response?.header?.body?.customersintransition || [];

      if (!Array.isArray(fetchedData)) {
        fetchedData = [fetchedData];
      }

      setUserData(fetchedData);
    } catch (error) {
      console.error("Failed to fetch form data:", error);
      setUserData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectedUser = (data) => {
    console.log("Selected User Data:---------", data);
    localStorage.setItem("selectedUser", JSON.stringify(data));
    setCurrentStep(1);
    setFormDataCollected({ firstName:data?.firstname, lastName:data?.lastname, middlename:data?.middleName, country:data?.countryid, dob: new Date(data?.dateofbirth), address1:data?.address1, address2:data?.address2, stateid:data?.stateid, city:data?.cityname, email:data?.emailaddress, zip:data?.zip, phoneno:data?.phonenumber, nationalitycountry:data?.countryid, defaultLogin:'1' });
  };

  const columns = [
    { field: "firstname", headerName: "User Name", width: 130 },
    { field: "dateofbirth", headerName: "DOB", width: 120 },
    { field: "phonenumber", headerName: "Phone Number", width: 150 },
    { field: "emailaddress", headerName: "Email", width: 200 },
    { field: "countryid", headerName: "Customer Number", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleSelectedUser(params.row)}
        >
          Select User
        </Button>
      ),
    },
  ];

  const handleIsMerchant = (stepData) => {
    console.log(stepData)
    if (stepData?.ismerchant === true || stepData?.ismerchant === "true") {
      setIsMerchant(true);
    } else {
      setIsMerchant(false)
    }
  }

  const fetchCustomerSubType = async () => {
    try {
      const res = await getCustomerSubTypes(202, selectedCustomerType);

      // Handle both cases: array and single object
      const record = res?.data?.body?.record;

      // Check if record is an array or a single object
      const transformedSubCustomerType = Array.isArray(record)
        ? record.map((item) => ({
            key: item.usersubtype.subtypeID,
            value: item.usersubtype.subtypeID,
            label: item.usersubtype.name,
          }))
        : record?.usersubtype // If single object
        ? [
            {
              key: record.usersubtype.subtypeID,
              value: record.usersubtype.subtypeID,
              label: record.usersubtype.name,
            },
          ]
        : [
            {
              key: "not-available",
              value: "not-available",
              label: "Not Available",
            },
          ];

      // Set the transformed data to state
      setCustomerSubTypes(transformedSubCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchCustomerType = async () => {
    try {
      const res = await getCustomerTypes(201);
      const transformedCustomerType =
        (await res?.data?.body?.record?.length) > 0
          ? res?.data?.body?.record?.map((item) => ({
              key: item.usertype.typeID,
              value: item.usertype.typeID,
              label: item.usertype.name,
            }))
          : [
              {
                key: "not-available",
                value: "not-available",
                label: "Not Available",
              },
            ];
      setCustomerTypes(transformedCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(()=> {
    if(selectedCustomerType) {
      fetchCustomerSubType();
    }
  },[selectedCustomerType]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const onSubmit = async (data, formData) => {
    setLoading(true);
    setNewUser("");
    setError("");

    const requiredFields = formData
      .filter((field) => field.validation?.required)
      .map((field) => field.name);

    const missingFields = requiredFields.filter(
      (fieldName) =>
        !data[fieldName] || data[fieldName].toString().trim() === ""
    );

    if (missingFields.length > 0) {
      return;
    }

    console.log(data);

    // let phoneNo = data.areaCode.value + data.phoneno;
    let phoneNo = data.phoneno;
    let requestData = { ...data }; // Shallow copy

    requestData.telephoneno = data.phoneno;

    console.log(phoneNo);

    if (data.email === "" || data.email === undefined) {
      const sanitizedPhone = phoneNo.replace("+", "");
      requestData.email = `${sanitizedPhone}@4pay.ph`;
      requestData.noEmail = 1;

      console.log(requestData.email);
      console.log(sanitizedPhone);
    } else {
      requestData.noEmail = 0;
    }

    if (requestData?.dob) {
      requestData.dob = formatDate(requestData.dob);
    }

    if (
      new Date().getFullYear() - parseInt(requestData.dob.split("-")[0]) <
      18
    ) {
      setAlert({
        showAlert: true,
        message:
          "Thank you for your interest in opening an account with us. However, your date of birth indicates that you are unable to hold an account as an individual. But you are able to hold an account with a parent or guardian.",
        severity: "error",
        header: "Error",
      });
      return;
    }

    if (requestData?.phoneno) {
      requestData.phoneno = phoneNo;
    }

    let extendedFields = {};

    formData.forEach((item) => {
      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    requestData.extendedFields = JSON.stringify(extendedFields);

    try {
      const emailExists = await CheckIfEmailExists(requestData);

      if (emailExists.callStatus == 0) {
        setAlert({
          showAlert: true,
          message: `${emailExists.payload.data.header.msg}`,
          severity: "error",
          header: "Error",
        });
        throw new Error(`${emailExists.payload.data.header.msg}`);
      }

      const response = await NewUser(requestData, agent["User"].id, isMerchant);

      let callStatus = response.data.payload.callStatus;
      let userId;
      if (callStatus == 1) {
        userId = response.data.payload.userid;
        setNewUser("User created successfully");
        updateState();
        setCurrentStep(0);
        setSearchText("");
        setUserData([]);
        setCustomerTypes([]);
        setCustomerSubTypes([]);
        setAddBussinessToggleBit(false);

        setAlert({
          showAlert: true,
          message: "User Created Successfully",
          severity: "success",
          header: "Success",
          userId: userId,
        });

        setFormDataCollected({}); // Clear all previously collected form data

        updateState(); // Update state after user is created

        if (userBase64) {
          let newPicture = await PictureNew(userId, userBase64);
        }

        try {
          const externalAccountCreation = await createExternalAccounts(
            requestData,
            userId,
            agent["User"].id,
            isOperator,
            parentuserid
          );

          // console.log(externalAccountCreation)
          let callStatus = externalAccountCreation.data.payload.callStatus;
          if (callStatus != 1) {
            setError(`${externalAccountCreation.data.payload.msg}`);
          }
        } catch (error) {
          
        }
      } else {
        setError(`${response.data.payload.msg}`);
        throw new Error(`${response.data.payload.msg}`);
      }
    } catch (error) {
      console.error(error);
      setError("An error occurred while creating the user.");
      setAlert({
        showAlert: true,
        message: `${error}`,
        severity: "error",
        header: "error",
      });
    }

    setLoading(false);
  };

  const handleFieldClick = (field) => {
    console.log("Field clicked in group:", field)
    if(field.formgroup === "Personal Information") {
      setCurrentStep(1);
    } else if(field.formgroup === "Contact Information") {
      setCurrentStep(2);
    } else if(field.formgroup === "Business Information") {
      setCurrentStep(3);
    }
  }

  const handleAddBussinessToggleBit = () => {
    setAddBussinessToggleBit((prev) => {
      if (!prev) {
        setSteps((prevSteps) => [
          ...prevSteps,
          { label: "Business", index: prevSteps.length },
        ]);
      } else {
        setSteps((prevSteps) => prevSteps.filter((step) => step.label !== "Business"));
      }
      return !prev;
    });
  }

  return (
    <BaseDrawer
      open={open}
      handleClose={closeModal}
      height="90vh"
      title={currentStep == 0 ? "" : "Create New MoneyGram User"}
    >
      <Box
        className="centered-content"
        // sx={{ overflow: "auto" }}
        sx={{
          height:'100%',
          width:'100%',
          overflow: "auto", // Enable scrolling for overflowing content
          maxHeight: "90vh", // Limit the height to the viewport
        }}
      >
        {currentStep > 0 && <Typography
          sx={{
            display:"flex",
            alignItems:"center",
            fontFamily: "'Nunito'",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            color: "#3A3A3A",
            zIndex: 0,
            marginLeft:'16px',
            cursor: "pointer", // Makes it look clickable
            "&:hover": { color: "#272626" }, // Changes color on hover (optional)
            // "&:hover": { color: "#1976d2" }, // Changes color on hover (optional)
          }}
          onClick={() => setCurrentStep(0)} // Go back to Step 1
        >
          <ArrowBackIos sx={{ fontSize: 15 }} />
          Back to Search User
        </Typography>}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute", // Absolute positioning to center
              left: "50%",
              transform: "translateX(-50%)", // Translate to center it properly
              width: "220px", // Adjust the width of the step wizard as needed
              height: "100px",
              zIndex: "1",
              marginTop: "20px",
            }}
          >
            <CustomStepWizard
              className="custom-step-wizard"
              steps={steps}
              current={currentStep}
              onStepChange={handleStepChange}
            />
          </Box>
        </Box>

        <Box sx={{ marginBottom: "60px" }} />

        {currentStep === 0 ? (
          <Box
            className="customer-profile-container-modal"
            sx={{
              overflowY: "auto", // Allow vertical scrolling
              maxHeight: "calc(90vh - 60px)", // Adjust based on header/footer height
            }}
          >
            <Box
              className="customer-details"
              sx={{
                display: "flex",
                justifyContent: "center" /* Center the panels horizontally */,
                alignItems: "flex-start" /* Align panels at the top */,
                flexDirection: "column",
                whiteSpace: "nowrap",
                overflowX: "unset",
                zIndex: "1",
                height:'100%'
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Nunito'",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "21.4825px",
                  color: "#3A3A3A",
                  zIndex: 0,
                }}
              >
                Search New MoneyGram User
              </Typography>

              <Box className="search-container">
                <TextField
                  placeholder="Card Number, User ID, etc."
                  value={searchText}
                  onChange={handleInputChange}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      fetchMoneyGramUsers(); // Call your function on Enter key press
                    }
                  }}
                  variant="standard"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                    sx: {
                      borderRadius: "33px",
                      color: "#000",
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton onClick={fetchMoneyGramUsers} edge="start">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={fetchMoneyGramUsers} edge="end">
                          <MapIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInputBase-root": {},
                    "& .MuiInputBase-input": {
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center", // Center horizontally
                  alignItems: "flex-start", // Align at the top
                  flexDirection: "row",
                  whiteSpace: "nowrap",
                  // overflowX: "auto",
                  zIndex: "1",
                  width:'100%'
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : userData && userData.length > 0 ? (
                  <Box className="customer-table-container p-4">
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start", // Center horizontally
                        alignItems: "flex-start", // Align at the top
                        flexDirection: "row",
                        whiteSpace: "nowrap",
                        // overflowX: "auto",
                        zIndex: "1",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "'Nunito'",
                          fontStyle: "normal",
                          fontWeight: 500,
                          fontSize: "21.4825px",
                          paddingLeft:'16px',
                          color: "#3A3A3A",
                          zIndex: 0,
                          "@media (min-width: 1920px)": {
                            // marginLeft: "50px",
                          },
                        }}
                      >
                        Results: {userData && userData.length > 0 ? userData.length : 0}
                      </Typography>
                    </Box>
                    <MoneyGramTableDynamic
                      userData={userData}
                      handleSelectedUser={handleSelectedUser}
                      editAllowed={securityPermissions.updateallowed}
                      selectedUser={selectedUser}
                      selectedUserData={selectedUserData}
                      targetID="offcanvasRight"
                      filterType={filterType}
                      searchText={searchText}
                    />
                  </Box>
                ) : (
                  <Typography variant="h6" sx={{ mt: 2, color: "gray" }}>
                    No data available
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box sx={{ padding: "20px", height:'100%' }}>
            <Box
              className="customer-details"
              sx={{
                display: "flex",
                justifyContent: "center" /* Center the panels horizontally */,
                alignItems: "flex-start" /* Align panels at the top */,
                flexDirection: "row",
                whiteSpace: "nowrap",
                overflowX: "unset",
                zIndex: "1",
              }}
            >
              <CustomForm
                ref={formRef}
                formName={"newuser"}
                formValues={formDataCollected}
                fieldRendererType="registration"
                conditionalFields={conditionalFields}
                useStep={true}
                onNext={handleIsMerchant}
                onPrevious={currentStep > 0 ? handlePrevious : null}
                onSubmit={onSubmit}
                buttonText={"Add User"}
                loadingButtonText={"Adding User..."}
                triggerFields={triggerFields}
                twoColumns={true}
                buttonInPanel={true}
                containerText={"Add New User"}
                isRegistration={true}
                conditionalGroups={conditionalGroups}
                customerTypes={customerTypes}
                customerSubTypes={customerSubTypes}
                setSelectedCustomerType={setSelectedCustomerType}
                onFieldClick={handleFieldClick}
                handleAddBussinessToggleBit={handleAddBussinessToggleBit}
              />
            </Box>
            {/* <form>
                <TextField label="First Name" fullWidth margin="normal" />
                <TextField label="Last Name" fullWidth margin="normal" />
                <TextField label="Email" type="email" fullWidth margin="normal" />
                <TextField label="Phone Number" fullWidth margin="normal" />
                <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={() => console.log("Submit Form")}>
                  Submit
                </Button>
              </form> */}
          </Box>
        )}
      </Box>
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false });
          if (alert.severity === "success") {
            handleClose();
            onCreate(alert.userId);
          }
        }}
        autoclose={alert.severity === "error" ? false : true}
      />
    </BaseDrawer>
  );
}

export default memo(CustomMoneyGramModal);

{/*<DataGrid
                    rows={userData}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10, 20]}
                  /> */}
